module.exports = __webpack_public_path__ + "img/circle_waves.776a9c6c.svg";